var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0039 13.25H15.5C15.25 13.25 15 13.5 15 13.75V19.0039C15 19.25 15.25 19.5 15.5 19.5H17.0039C17.25 19.5 17.5 19.25 17.5 19.0039V13.75C17.5 13.5 17.25 13.25 17.0039 13.25ZM9.50391 15.75H8C7.74922 15.75 7.5 16 7.5 16.25V19.0039C7.5 19.25 7.74922 19.5 7.99805 19.5H9.50195C9.75 19.5 10 19.25 10 19.0039V16.25C10 16 9.75 15.75 9.50391 15.75ZM13.2539 10.75H11.75C11.5 10.75 11.25 11 11.25 11.25V19.0039C11.25 19.25 11.5 19.5 11.75 19.5H13.2539C13.5 19.5 13.75 19.25 13.75 19.0039V11.25C13.75 11 13.5 10.75 13.2539 10.75ZM15 2V7H20L15 2Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15 7V2H6.875C5.83945 2 5 2.83945 5 3.875V20.125C5 21.1602 5.83945 22 6.875 22H18.125C19.1605 22 20 21.1605 20 20.125V7H15ZM10 19.0039C10 19.25 9.75 19.5 9.50391 19.5H8C7.74922 19.5 7.5 19.25 7.5 19.0039V16.25C7.5 16 7.74922 15.75 7.99805 15.75H9.50195C9.75 15.75 10 16 10 16.25V19.0039ZM13.75 19.0039C13.75 19.25 13.5 19.5 13.2539 19.5H11.75C11.5 19.5 11.25 19.25 11.25 19.0039V11.25C11.25 11 11.5 10.75 11.75 10.75H13.2539C13.5 10.75 13.75 11 13.75 11.25V19.0039ZM17.5 19.0039C17.5 19.25 17.25 19.5 17.0039 19.5H15.5C15.25 19.5 15 19.25 15 19.0039V13.75C15 13.5 15.25 13.25 15.5 13.25H17.0039C17.25 13.25 17.5 13.5 17.5 13.75V19.0039Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReports);
export default __webpack_public_path__ + "static/media/icon-reports.fda3148c38208c195640a32173cefb41.svg";
export { ForwardRef as ReactComponent };